module.exports = __webpack_public_path__ + "static/font-6773d76b3fda2d093ea8115589c4d63c.eot";